import React from 'react';
import { View, Pressable, ViewStyle, StyleSheet } from 'react-native';
import { Theme } from '../../utils/theme';

interface CardProps {
  children: React.ReactNode;
  onPress?: () => void;
  selected?: boolean;
  disabled?: boolean;
  variant?: 'default' | 'outlined' | 'elevated';
  style?: ViewStyle;
}

export default function Card({
  children,
  onPress,
  selected = false,
  disabled = false,
  variant = 'default',
  style,
}: CardProps) {
  const cardStyle = [
    styles.base,
    styles[variant],
    selected && styles.selected,
    disabled && styles.disabled,
    style,
  ];

  if (onPress) {
    return (
      <Pressable
        style={({ pressed }) => [
          ...cardStyle,
          pressed && !disabled && styles.pressed,
        ]}
        onPress={onPress}
        disabled={disabled}
      >
        {children}
      </Pressable>
    );
  }

  return <View style={cardStyle}>{children}</View>;
}

const styles = StyleSheet.create({
  base: {
    ...Theme.components.card,
  },
  
  // Variants
  default: {
    backgroundColor: Theme.colors.surface,
    borderWidth: 1,
    borderColor: Theme.colors.border,
  },
  outlined: {
    backgroundColor: Theme.colors.transparent,
    borderWidth: 1,
    borderColor: Theme.colors.border,
  },
  elevated: {
    backgroundColor: Theme.colors.surface,
    borderWidth: 0,
    ...Theme.shadows.md,
  },
  
  // States
  selected: {
    ...Theme.components.cardSelected,
  },
  disabled: {
    opacity: 0.5,
  },
  pressed: {
    opacity: 0.8,
    transform: [{ scale: 0.98 }],
  },
}); 